import React from "react";
import Dialog from "../../../shared/dialog";
import MyButton from "../../../shared/buttons/primary";
import "./index.scss";

const ConfirmModal = (props) => {
  const { onClose, onAccept, message } = props;
  return (
    <Dialog
      id="confirm-dialog"
      className={"confirm-dialog"}
      isShow={true}
      onCloseRequest={onClose}
      closeOnOverlayClick={true}
    >
      <div>
        <h2 className="text-center">{message}</h2>
        <div className="booking-form__btns">
          <MyButton className="me-1" myVariant="cancel" onClick={onClose}>
            いいえ
          </MyButton>
          <MyButton myVariant="accept" onClick={onAccept}>
            はい
          </MyButton>
        </div>
      </div>
    </Dialog>
  );
};

export default React.memo(ConfirmModal);
